<div *ngIf="switchProps">
  <span [innerHTML]="switchProps.labelKey | translate"></span>
  <eds-switch
    id="calcSwitchProps"
    [disabled]="false"
    [label]="label"
    [labelOff]="switchProps.labelOffKey | translate"
    [labelOn]="switchProps.labelOnKey | translate"
    [state]="switchProps.state"
    (switchPressed)="onSwitchPressed($event)"
    ariaLabelledbyStr="calcSwitchLabel"
    labelId="calcSwitchLabel"
  ></eds-switch>
</div>

<div
  *ngIf="toggleButtons.length > 0"
  edsFlexbox
  flexWrap="wrap"
  alignItems="center"
>
  <div edsPadding edsPaddingRight="md" edsPaddingBottom="xs">
    <span class="small">{{ label }}</span>
  </div>
  <eds-toggle
    [toggleButtons]="toggleButtons"
    (toggleActive)="onToggleActive($event)"
  ></eds-toggle>
</div>
